class CommCodeModel {
	constructor(commCode) {
		const { commCd, commCdName } = commCode;

		this.label = commCdName.trim();
		this.value = commCd.trim();
	}
}

export default CommCodeModel;
